import { Static, Type } from "@fastify/type-provider-typebox";

//Can add more to this as we see fit.
export const AdminPartialUser = Type.Object({
  id: Type.Number(),
  uuid: Type.String(),
  email: Type.String(),
  name: Type.String(),
  sellerId: Type.String(),
  startSyncAt: Type.String(),
  endSyncAt: Type.String(),
  numOfSyncStarted: Type.Number(),
  totalLogins: Type.Number(),
  totalMinutesSpentInApp: Type.Number(),
  userSessionStart: Type.String(),
});
export type AdminPartialUser = Static<typeof AdminPartialUser>;

export const AdminPartialShipment = Type.Object({
  id: Type.Number(),
  createdAt: Type.String(),
  status: Type.String(),
  transportType: Type.String(),
  step4EndDate: Type.String(),
});
export type AdminPartialShipment = Static<typeof AdminPartialShipment>;

export const AdminPartialBatch = Type.Object({
  id: Type.Number(),
  createdAt: Type.String(),
  status: Type.String(),
  shipments: Type.Array(AdminPartialShipment),
  step1EndDate: Type.String(),
  step2EndDate: Type.String(),
  step3EndDate: Type.String(),
  shipmentType: Type.String(),
});
export type AdminPartialBatch = Static<typeof AdminPartialBatch>;

export const AdminGetUsersResponse = Type.Object({
  users: Type.Array(AdminPartialUser),
  count: Type.Number(),
});
export type AdminGetUsersResponse = Static<typeof AdminGetUsersResponse>;

export const GetAdminMirrorJwtResponse = Type.Object({
  token: Type.String(), //The JWT 
});
export type GetAdminMirrorJwtResponse = Static<typeof GetAdminMirrorJwtResponse>;

export const AdminGetBatchesResponse = Type.Object({
  batches: Type.Array(AdminPartialBatch),
});
export type AdminGetBatchesResponse = Static<typeof AdminGetBatchesResponse>;
